import { type LegalDocument, unfilledPlaceholders } from "@netkeep/legal";
import { useEffect } from "react";
import { Link } from "react-router";
import { shortDate } from "@/lib/format";
import { Card } from "./ui";

/** Renders a Terms / Privacy document from @netkeep/legal (shared with the mobile app). */
export function LegalDocumentView({ doc }: { doc: LegalDocument }) {
  const unfilled = unfilledPlaceholders();
  const other = doc.slug === "terms" ? { to: "/privacy", label: "Privacy Policy" } : { to: "/terms", label: "Terms of Use" };

  useEffect(() => {
    document.title = `${doc.title} · NetKeep`;
  }, [doc.title]);

  return (
    <article className="legal">
      <header className="stack-xs">
        <h1 className="page-title">{doc.title}</h1>
        <p className="muted">Effective {shortDate(doc.effectiveDate)}</p>
      </header>
      {unfilled.length > 0 ? (
        <p className="text-warning" role="alert">
          Draft: owner details are not filled in yet ({unfilled.join(", ")}).
        </p>
      ) : null}
      <Card>
        <p className="picker__kicker">IN SHORT</p>
        <p>{doc.summary}</p>
      </Card>
      {doc.sections.map((section) => (
        <section key={section.heading} className="legal__section">
          <h2 className="heading">{section.heading}</h2>
          {section.paragraphs.map((p) => (
            <p key={p}>{p}</p>
          ))}
          {section.bullets ? (
            <ul>
              {section.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          ) : null}
        </section>
      ))}
      <p className="muted">
        See also the <Link to={other.to} className="link">{other.label}</Link>.
      </p>
    </article>
  );
}
